module.exports = __webpack_public_path__ + "static/Wraith-89b641b68e2123ea447241235ac607a8.jpg";